import './skeleton.scss';

export const Skeleton = ({
  skeletonLines = 1,
  width,
  height,
}: {
  skeletonLines?: number;
  width?: number;
  height?: number;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const style: any = {};

  if (width) {
    style.width = `${width}px`;
  }
  if (height) {
    style.height = `${height}px`;
  }

  return (
    <div className="skeleton">
      {[...Array(skeletonLines)].map((_item, i) => (
        <div key={i} className="skeleton-line" style={style} />
      ))}
    </div>
  );
};
